module.exports = __webpack_public_path__ + "static/hug-arms-ede70bf43715c25f9dd7c279177c9a5d.png";